if (!customElements.get('custom-scrollbar')) {
  customElements.define(
    'custom-scrollbar',
    class CustomScrollbar extends HTMLElement {
      constructor() {
        super();

        this.cardSpacing = 20;

        this.buttonContainer = this.querySelector('[data-button-container]');
        this.navButtons = this.buttonContainer.querySelectorAll('button');

        this.carousel = this.querySelector('.custom-scrollbar');

        let style = getComputedStyle(this.carousel);
        let spacingProperty = style.getPropertyValue('--spacing');
        this.cardSpacing = parseInt(spacingProperty);

        this.scrollTicking = false;
        this.index = 0;
        this.maxIndex = this.productCardCount - 1;

        this.carousel.addEventListener('scroll', this.handleScroll.bind(this));

        this.navButtons.forEach((navButton) => {
          navButton.addEventListener('click', (e) => {
            e.preventDefault();
            let moveBy = parseInt(navButton.dataset.move);
            this.moveCarousel(moveBy);
          });
        });

        window.addEventListener('resize', this.handleWindowResize.bind(this));
      }
      get maxIndex() {
        return this._maxIndex;
      }
      set maxIndex(maxIndex) {
        this._maxIndex = maxIndex;
      }
      get productCardCount() {
        return this.productCards.length;
      }
      get productCards() {
        return this.carousel.querySelectorAll('.scroll-trigger');
      }
      moveCarousel(moveBy) {
        this.index = Math.min(Math.max(this.index + moveBy, 0), this.maxIndex);
        this.carousel.scrollLeft = this.index * this.cardWidth;
      }
      handleScroll(e) {
        if (!this.scrollTicking) {
          window.requestAnimationFrame(() => {
            this.updateActivePage();
            this.scrollTicking = false;
          });
          this.scrollTicking = true;
        }
      }
      updateActivePage() {
        this.calculateCardWidth();
        this.index = Math.round(this.carousel.scrollLeft / this.cardWidth);

        this.navButtons.forEach((button) => button.removeAttribute('disabled'));

        if (this.index < 1) {
          this.querySelector('button[data-move="-1"').setAttribute('disabled', true);
        } else if (this.index == this.maxIndex) {
          this.querySelector('button[data-move="1"').setAttribute('disabled', true);
        }

        let style = getComputedStyle(this.carousel);
        let cardsPerPageProperty = style.getPropertyValue('--cards-per-page');
        let cardsPerPage = parseInt(cardsPerPageProperty);
        if (cardsPerPage >= this.productCards.length) {
          this.navButtons.forEach((button) => button.classList.add('hidden'));
        } else {
          this.navButtons.forEach((button) => button.classList.remove('hidden'));
        }
      }
      calculateCardWidth() {
        this.cardWidth = this.productCards[0].getBoundingClientRect().width + this.cardSpacing;
      }
      calculateMaxIndex() {
        let perScreen = Math.max(1, Math.ceil(this.carousel.getBoundingClientRect().width / this.cardWidth));

        if (perScreen <= 1) {
          this.maxIndex = this.productCardCount - 1;
        } else {
          this.maxIndex = this.productCardCount - perScreen;
        }
      }
      handleWindowResize() {
        this.calculateCardWidth();
        this.calculateMaxIndex();
        this.updateActivePage();
      }
      init() {
        this.calculateCardWidth();
        this.calculateMaxIndex();
        this.updateActivePage();
      }
      connectedCallback() {
        if (this.productCards.length > 0) {
          this.init();
        }
      }
    }
  );
}
